import { Config, DomainsConfig } from './index';
import { LOCALE } from '../i18n';
import { AVAILABLE_LOCALES } from '@crazygames/countries/locales';
import { getLocaleDomainDetails } from '@crazygames/countries/url-utils';

const featureEnv = process.env.REACT_APP_FEATURE_ENV;

//Cast, because we will add every locale right afterwards
const domains: DomainsConfig = {} as DomainsConfig;
AVAILABLE_LOCALES.forEach((locale) => {
  domains[locale] = getLocaleDomainDetails(locale, 'dev');
});

const config: Config = {
  graph: 'https://graph.dev-crazygames.be',
  ga4ID: 'G-QZHWTZQ3TH',
  firebase: {
    apiKey: 'AIzaSyDESdV81A6vor7xlKHWzJeR0qSUp5JjbOI',
    authDomain: 'crazygames-dev.firebaseapp.com',
    databaseURL: 'https://crazygames-dev.firebaseio.com',
    projectId: 'crazygames-dev',
    storageBucket: 'crazygames-dev.appspot.com',
    messagingSenderId: '103229312039',
  },
  sentry: {
    dsn: 'https://b1c4f739f0784719a50fc8252af97e43@sentry.io/1284881',
  },
  aws: {
    filesDomain: 'files.dev-crazygames.be',
    videoCdnPrefix: 'https://videos.dev-crazygames.be',
    imagesCdnPrefix: 'https://imgs.dev-crazygames.be',
  },
  domains: domains,
  kidSiteDomain: {
    base: 'https://kids.dev-crazygames.be',
  },
};

if (featureEnv) {
  config.graph = `https://graph-${featureEnv}.dev-crazygames.be`;

  // Append `-featureEnv` to the base of each domain
  Object.keys(config.domains).forEach((key) => {
    const domain = config.domains[key as LOCALE];
    const domainsSplit = domain.base.split('.');
    domainsSplit[0] = `${domainsSplit[0]}-${featureEnv}`;
    domain.base = domainsSplit.join('.');
  });
}

export default config;
